// extracted by mini-css-extract-plugin
export default {"feedback":"nw","radio_button":"ow","title":"pw","text":"qw","main_btn":"rw","radio_wrapper":"sw","buttons_wrapper":"tw"};
    if(module.hot) {
      // 1714422955967
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  